import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
const debounce = require('lodash.debounce');
import PublishProjectService from '../publish-project-service.js';
import { errorMessage } from '@/utils/message.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    Header,
    Search,
    Menu,
    Bottom,
    ProcessNavigation
  },
  data () {
    return {
      // processList: ['业务流程及准备材料', '编辑项目信息', '编辑受让资格', '上传附件信息', '重大事项提示', '承诺信息', '提交申请'],
      step: 6,
      id: '',
      oldId: '',
      // tradeType: '',
      isCreated: true,
      isAgree: false,
      submitStatus: 'init',
      projectType: 1, // 项目类型
      projectSubType: 1, // 项目子类
      title: '承诺信息',
      descTitle: '转让方承诺',
      citytitle: ''
    };
  },
  computed: {
    ...mapGetters([
      'processList',
      'tradeType',
      'fileinfo'
    ])
  },
  created () {
    window.scrollTo(0, 0);
    // this.tradeType = this.$route.query.tradeType;
    this.$store.commit('SET_TRADE_TYPE', this.$route.query.tradeType);
    console.log(this.tradeType);
    this.projectType = this.$route.query.projectType; // 项目类型
    this.projectSubType = this.$route.query.projectSubType; // 项目子类
    if (Number(this.tradeType) === 2) {
      // this.processList = ['业务流程及准备材料', '编辑项目信息', '上传附件信息', '重大事项提示', '承诺信息', '提交申请'];
      this.step = 3;
    }
    if (Number(this.tradeType) === 3) {
      this.$store.commit('SET_PROCESS_LIST', ['业务流程及准备材料', '编辑项目信息', '承诺信息', '提交申请']);
      this.step = 3;
    }
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;

    // 农机设备出租
    if (Number(this.projectType) === 6 || (Number(this.projectType) === 7 && Number(this.projectSubType) === 2)) {
      this.title = '确定承诺信息';
      this.descTitle = '出租方委托承诺';
    }
  },
  methods: {
    previousStep () {
      this.$router.back();
    },
    next: debounce(function () {
      if (this.submitStatus === 'ongoing') { return; }
      this.submitStatus = 'ongoing';
      PublishProjectService.submit(this.id).then(res => {
        if (res && res.code === '0') {
          this.submitStatus = 'success';
          this.$router.push('/publish-project/success?tradeType=' + this.tradeType);
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
          this.submitStatus = 'failed';
        } else {
          errorMessage('保存承诺信息失败');
          this.submitStatus = 'failed';
        }
      }, (error) => {
        this.submitStatus = 'failed';
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存承诺信息失败');
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    })
  }
};
